import axiosInstance, { axiosInstanceCommon } from "../axios";

// Get manage divides
export async function getManageDivides(keyword?: string) {
  const params = keyword ? { keyword } : {};
  const response = await axiosInstanceCommon.get("/manage-divides", { params });
  return response.data;
}

// Get items
export async function getItems(keyword?: string) {
  const params = keyword ? { keyword } : {};
  const response = await axiosInstanceCommon.get("/items", { params });
  return response.data;
}

// Get items detail
export async function getItemsDetail(item_code: number) {
  const response = await axiosInstanceCommon.get(`/items/${item_code}`);
  return response.data;
}

// Download file
export async function downloadFile(file_id: number) {
  const response = await axiosInstanceCommon.get(`/files/${file_id}/download`, {
    responseType: "blob"
  });
  return response.data;
}

// Get me
export async function getMe() {
  const response = await axiosInstance.get("/me");
  return response.data.data;
}

// Get user
export async function getUser() {
  const response = await axiosInstance.get("/users");
  return response.data.data;
}
